import {Directive} from '@angular/core';
import {ErrorStateMatcher} from '@angular/material/core';
import {FormControl, FormGroupDirective, NgForm} from '@angular/forms';

@Directive({
  selector: '[appDirtyErrorStateMatcherCard]'
})
export class DirtyErrorStateMatcherCardDirective implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && sessionStorage.getItem('cardFormSubmitted') === 'true';
    return !!(control && control.invalid && ((control.touched && control.dirty) ) || isSubmitted);
  }
}

